import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import Button from "react-bootstrap/Button";
import { onMessageListener, requestForToken } from "./firebase-config";

const Notification = () => {
  const [notification, setNotification] = useState({ title: "", body: "" });

  const notify = () => {
    toast(
      (t) => (
        <span style={{ color: "#454545" }}>
          {notification?.title} <br />
          <hr style={{margin:"8px 0"}}/>
          {notification?.body}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "6px auto",
            }}
          >
            {/* <Button
            style={{
              textAlign: "center",
              color: "#ffffff",
              fontSize: "16px",
              borderRadius: "8px",
            }}
            variant="primary"
            onClick={() => toast.dismiss(t.id)}
          >
            Otp Sent Successfully!
          </Button> */}
          </div>
        </span>
      ),
      {
        duration: 10000,
        
        style: {
          // background: "#454545",
          // color: "#454545",
          fontSize: "16px",
          border:"1px solid #FFC600",
          justifyContent: "center",
          alignItems: "center",
          padding: "2px",
        },
      }
    );
  };

  useEffect(() => {
    // Ask for FCM permission + token
    requestForToken();

    // Listen for messages in the foreground
    const listen = async () => {
      try {
        const payload = await onMessageListener();
        setNotification({
          title: payload?.notification?.title || "Notification",
          body: payload?.notification?.body || "",
        });
        console.log(payload?.notification?.title, payload?.notification?.body);
      } catch (err) {
        console.error("Failed to receive message: ", err);
      }
    };

    listen();
  }, []);

  // Show toast when notification updates
  useEffect(() => {
    if (notification.title || notification.body) {
      notify("some message");
    }
  }, [notification]);

  return <Toaster position="top-center" reverseOrder={false} />;
};

export default Notification;
